import { Formik } from 'formik'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import Button from '../../../../components/buttons/buttons.component'
import {
	NumberInput,
	FakePasswordInput
} from '../../../../components/form-components/inputs.component'
import StyledInputContainer from './../../../../components/form-components/styled-input-container.component'
import InnerPageContainer from './../../../../components/layout/private/inner-page-container.component'
import Title from './../../../../components/typography/title.component'
import Yup from './../../../../helpers/custom-yup'
import { createPoints } from './create-points.actions'
import { StyledForm } from './styles.style'

class CreatePointsPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.initialValues = {
			pointsQuantity: '',
			securityKey: ''
		}
	}

	shouldComponentUpdate(nextProps) {
		const { isCreating } = this.props
		const { errors } = nextProps

		const pointsCreated = isCreating && !nextProps.isCreating
		const withNoErrors = !errors || !errors.length
		if (pointsCreated && withNoErrors) {
			this.formActions.resetForm()
		}

		return isCreating != nextProps.isCreating
	}

	render() {
		return (
			<InnerPageContainer small>
				<Title>Criar Pontos Muviflex</Title>
				<Formik
					initialValues={this.initialValues}
					onSubmit={onSubmit.bind(this)}
					validationSchema={Yup.object().shape({
						pointsQuantity: Yup.number()
							.min(1, 'Quantidade de pontos inválida')
							.required('Informe a quantidade de pontos'),
						securityKey: Yup.string()
							.matches(/^[0-9]{4}$/, 'Chave de segurança inválida')
							.required('Informe a chave de segurança')
					})}
					render={props => (
						<StyledForm
							className="form"
							onSubmit={props.handleSubmit}
							noValidate>
							<StyledInputContainer>
								<NumberInput
									id="pointsQuantity"
									label="Quantidade de pontos *"
									{...props}
								/>
							</StyledInputContainer>
							<StyledInputContainer>
								<FakePasswordInput
									id="securityKey"
									label="Chave de segurança *"
									maxLength={4}
									{...props}
								/>
							</StyledInputContainer>
							<Button data-permission="9DC13303C619872C338BDD28CCFA73DC4D058875" primary type="submit">
								Criar pontos
							</Button>
						</StyledForm>
					)}
				/>
			</InnerPageContainer>
		)
	}
}

function onSubmit(values, actions) {
	this.formActions = actions
	this.props.createPoints(values)
}

const mapStateToProps = ({ adminCreatePoints }) => {
	return {
		...adminCreatePoints
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			createPoints
		},
		dispatch
	)

const connectedCreatePointsPageComponent = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(CreatePointsPageComponent)
)

export { connectedCreatePointsPageComponent as ModuleRootComponent }
